"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Flex["default"];
  }
});
var _Flex = _interopRequireDefault(require("./Flex"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }